import { createEmailHistoryApiInstance, getForwardedHost } from 'utils/emailHistory/apiUtils';

/**
 * Activity Report AI Insights API
 */

export interface ActivityReportInsightParams {
  customerId: number;
  addressId: number;
  dateFrom: string;
  dateTo: string;
  positiveOnly?: boolean;
}

export interface InsightMetric {
  label: string;
  value: string;
  comparison?: string;
}

export interface InsightResponse {
  insightType: string;
  headline: string;
  body: string;
  sentiment: 'positive' | 'neutral' | 'warning' | 'negative';
  metric?: InsightMetric;
}

// Create API instance for AI insights
const aiInsightsApi = createEmailHistoryApiInstance('/api3.2/ai-insights');

/**
 * Generate AI insight for Activity Report
 * @param params - Filter parameters
 * @returns Promise with insight data
 */
export async function generateActivityReportInsight(
  params: ActivityReportInsightParams
): Promise<InsightResponse> {
  try {
    const { data } = await aiInsightsApi.post('/activity-report', params, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'x-forwarded-host': getForwardedHost(aiInsightsApi.defaults.baseURL),
      },
    });

    if (!data.success) {
      const error = new Error(data.error?.message || 'Failed to generate insight');
      (error as any).code = data.error?.code || 'GENERATION_FAILED';
      throw error;
    }

    return data.data;
  } catch (error: any) {
    // Normalize error
    if (error.response?.data?.error) {
      const apiError = error.response.data.error;
      const normalizedError = new Error(apiError.message || 'Failed to generate insight');
      (normalizedError as any).code = apiError.code;
      throw normalizedError;
    }
    throw error;
  }
}

export default generateActivityReportInsight;
